import React from 'react';
import { Link } from 'react-router-dom';

const RelatedTools = ({ currentPath }) => {
  const tools = [
    { path: '/', title: 'Calculadora de Horas', description: 'Somar e subtrair horas', icon: '➕' },
    { path: '/calculadora-de-horas-trabalhadas', title: 'Horas Trabalhadas', description: 'Calcule sua jornada semanal e mensal', icon: '🕐' },
    { path: '/calculadora-de-horas-extras', title: 'Horas Extras', description: 'Calcule 50% e 100% de adicional', icon: '💰' },
    { path: '/calculo-de-horas-extraordinarias', title: 'Cálculo Extraordinárias', description: 'Guia completo + calculadora', icon: '📋' },
    { path: '/calculadora-de-subtracao-de-horas', title: 'Subtração de Horas', description: 'Diferença entre horários', icon: '➖' },
    { path: '/calculadora-de-banco-de-horas', title: 'Banco de Horas', description: 'Controle seu saldo CLT', icon: '🏦' },
    { path: '/banco-de-horas-como-funciona', title: 'Banco de Horas — Guia', description: 'Como funciona, regras e saldo negativo', icon: '📖' },
    { path: '/calculadora-de-adicional-noturno', title: 'Adicional Noturno', description: 'Hora noturna reduzida', icon: '🌙' },
    { path: '/adicional-noturno-valor', title: 'Valor Noturno', description: 'Tabela de valores por salário', icon: '💵' },
    { path: '/adicional-noturno-horario', title: 'Horário Noturno', description: 'A partir de que horas começa', icon: '🕙' },
    { path: '/calculadora-de-tempo', title: 'Calculadora de Tempo', description: 'Somar, subtrair e converter tempo', icon: '⏱️' },
    { path: '/calculadora-de-minutos', title: 'Calculadora de Minutos', description: 'Somar e converter minutos', icon: '⏲️' },
    { path: '/contador-de-horas', title: 'Contador de Horas', description: 'Cronômetro para contar horas', icon: '⏳' },
    { path: '/converter-horas-em-dias', title: 'Horas para Dias', description: '72h, 48h, 36h são quantos dias', icon: '📅' },
    { path: '/jornada-de-trabalho', title: 'Jornada de Trabalho', description: '44h, 40h, 30h semanais por dia', icon: '👷' },
    { path: '/calculo-de-hora-trabalhada', title: 'Valor da Hora', description: 'Quanto vale sua hora de trabalho', icon: '🧮' },
    { path: '/quantas-horas-extras-por-dia', title: 'Limite Hora Extra', description: 'Quantas horas extras por dia', icon: '⚖️' },
  ];

  // Show max 6 related tools, prioritizing topical relevance
  const getRelatedTools = () => {
    const filtered = tools.filter(tool => tool.path !== currentPath);

    // Define topical clusters for smarter recommendations
    const clusters = {
      overtime: ['/calculadora-de-horas-extras', '/calculo-de-horas-extraordinarias', '/quantas-horas-extras-por-dia', '/calculo-de-hora-trabalhada'],
      noturno: ['/calculadora-de-adicional-noturno', '/adicional-noturno-valor', '/adicional-noturno-horario'],
      banco: ['/calculadora-de-banco-de-horas', '/banco-de-horas-como-funciona'],
      time: ['/calculadora-de-tempo', '/calculadora-de-minutos', '/contador-de-horas', '/converter-horas-em-dias', '/'],
      jornada: ['/calculadora-de-horas-trabalhadas', '/jornada-de-trabalho', '/calculo-de-hora-trabalhada'],
    };

    // Find which cluster the current page belongs to
    let currentCluster = null;
    for (const [name, paths] of Object.entries(clusters)) {
      if (paths.includes(currentPath)) { currentCluster = name; break; }
    }

    // Prioritize same-cluster tools, then others
    if (currentCluster) {
      const sameCluster = filtered.filter(t => clusters[currentCluster].includes(t.path));
      const otherTools = filtered.filter(t => !clusters[currentCluster].includes(t.path));
      return [...sameCluster, ...otherTools].slice(0, 6);
    }

    return filtered.slice(0, 6);
  };

  const relatedTools = getRelatedTools();

  return (
    <section className="mt-12">
      <h2 className="text-2xl font-heading font-bold text-dark-text mb-6">
        Outras Calculadoras
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {relatedTools.map((tool) => (
          <Link
            key={tool.path}
            to={tool.path}
            className="block p-6 bg-white rounded-lg border-2 border-border-gray hover:border-blue-primary transition-all hover:shadow-md group"
            data-testid={`related-tool-${tool.path}`}
          >
            <div className="flex items-start space-x-3">
              <span
                className="text-3xl mt-1 flex-shrink-0 group-hover:scale-110 transition-transform"
                role="img"
                aria-label={tool.title}
              >
                {tool.icon}
              </span>
              <div>
                <h3 className="font-semibold text-dark-text mb-1 group-hover:text-blue-primary transition-colors">
                  {tool.title}
                </h3>
                <p className="text-sm text-body-text">{tool.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedTools;
